import { useTranslation } from 'react-i18next';
import { Card } from '@/common/components/Card/Card';
import { Heading } from '@/common/components/Heading/Heading';
import { IconBadge } from '@/common/components/IconBadge/IconBadge';
import { Icon } from '@/common/components/Icons/Icon';
import { Label } from '@/common/components/Label/Label';
import { SkeletonInline } from '@/common/components/SkeletonInline/SkeletonInline';
import { Stack } from '@/common/components/Stack/Stack';
import { useBreakpoints } from '@/common/hooks/useBreakpoints';
import { useBudgetsSummary } from '@/common/integrations/menhir/employee/budgets/budgets.hooks';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';

export function BudgetsBalanceCard() {
  const { t } = useTranslation();
  const breakpoints = useBreakpoints(['md']);

  const { availableBalance, loading } = useBudgetsSummary();

  return (
    <Card size="md" plain>
      <Stack horizontal gap={breakpoints.md ? 'md' : 'sm'}>
        <IconBadge
          ratio={breakpoints.md ? 56 : 40}
          icon={<Icon icon="star" size={breakpoints.md ? 20 : 16} />}
        />
        <Stack gap={breakpoints.md ? 'xs' : undefined}>
          <Heading level={5}>{t('general.labels.balance')}</Heading>
          {loading ? (
            <SkeletonInline className="h-lg w-[12rem] md:h-xl" />
          ) : (
            <Label size={breakpoints.md ? 'xl' : 'lg'} bold>
              {MoneyUtils.moneyToString(availableBalance)}
            </Label>
          )}
        </Stack>
      </Stack>
    </Card>
  );
}
